import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Buttons, Content, Description } from './NoAppointment.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Text } from 'components/v2/Typography/Text';
import theme from 'kb-shared/theme';
import { analytics } from 'utilities/analytics';
import { pageUrl, RoutesPath } from 'utilities/pageUrl';

export const NoAppointment = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Content>
        <Description>
          <Text size="lg" color={theme.colors.neutral.navy} fontStyle="semibold">
            You Have No Upcoming Appointments!
          </Text>
          <Text size="xs" color={theme.colors.neutral.navy}>
            When you book an appointment, it will appear here.
          </Text>
        </Description>

        <Buttons>
          <Button
            category="primary"
            label="Schedule Appointment"
            onClick={() => {
              analytics.track(analytics.EVENTS.APPOINTMENT_SCHEDULE_CLICKED, {
                source: 'empty_state'
              });
              navigate(pageUrl.booking.bookingQuiz());
            }}
            size="md"
          />
          <Button
            category="primary-dark"
            label="Kindbody360"
            onClick={() => navigate(RoutesPath.KINDBODY_360)}
            size="md"
          />
        </Buttons>
      </Content>
    </div>
  );
};
